import React from 'react';
import styled from 'react-emotion';
import { cx } from 'helpers';

import { classes as cn } from 'shared/styles';

import { EscCloseBtn } from '../common';


const PanelFrame = ({ style = {}, children }) => (
  <div
    className={cx(
      "flex flex-column justify-between ph3",
      "moa-ff-sans black-70 lh-copy bg-white",
    )}
  >
    {children}
  </div>
);


const formattingHintRows = [
  [ <span className="b">Bold</span>, ['⌘', 'b'], '+' ],
  [ <span className="i">Italic</span>, ['⌘', 'i'], '+' ],
  [ <span className="strike">Strikethrough</span>, ['⌘', 'Opt', 's'], '+' ],
  [
    <pre className="ma0 ph1 bg-near-white dib b">
      <code>
        code block
      </code>
    </pre>,
    ['```']
  ],
  [
    <code
      className={cn.codeMark}
      style={{ fontSize: '14px' }}
    >
      code
    </code>,
    ['`code`']
  ],
  [
    <span>
      <ul className="ma0 pl3">
        <li>Bulleted list</li>
      </ul>
    </span>,
    ['*', 'Space']
  ],
  [
    <span>
      <ol className="ma0 pl3">
        <li>Numbered list</li>
      </ol>
    </span>,
    ['1.', 'Space']
  ],
  [
    <h2 className={cx('ma0', '-heading-base')}>
      Heading
    </h2>,
    ['#', 'Space']
  ],
];


// const editingHintRows = [
//   [
//     <span>Cursor movement</span>,
//     ['Ctrl', 'h/j/k/l'], '+' ]
//   ,
// ];

const applicationHintRows = [
  [ <span>Publish panel</span>, ['⌘', 'Shift', 'p'], '+' ],
  [ <span>Keyboard shortcuts</span>, ['⌘', '/'], '+' ],
];

const renderTwoColumnTable = (rows, tableClass) => (
  <table className={tableClass}>
    <tbody>
      {rows.map(row => (
        <tr key={row[1].join('-')}>
          <td className="pv1 f6">
            {row[0]}
          </td>
          <td className="pv1 tr f7">
            {row[1].map((key, idx) => (
              <span key={key}>
                {idx > 0 && (
                  <span className="mh1">
                    {row[2]}
                  </span>
                )}

                <kbd className={cx("-inline-code")}>
                  {key}
                </kbd>
              </span>
            ))}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

const H1 = ({children}) => <h1 className="f4 fw5 mt0 mb4 dark-gray">{children}</h1>;
const H2 = ({children}) => <h2 className="f5 fw5 mt0 mb2 mid-gray">{children}</h2>;

const Footnotes = ({className, children}) => (
  <div className={cx("relative f7 fw3 lh-title light-silver", className)}>
    {children}

    <span
      className="absolute left-0"
      style={{ top: '-20px' }}
    >
      ____
    </span>
  </div>
);

const WithSymbolLeft = styled('div')(props => ({
  position: 'relative',
  '&:before': {
    position: 'absolute',
    content: `'${props.symbol}'`,
    left: '-12px',
  },
}));


const BlogUserGuidePanel = ({ onCancel }) => (
  <PanelFrame>
    <div>
      <div className="flex justify-between items-center mv2">
        <EscCloseBtn onClick={onCancel} />
      </div>
    </div>

    <div className="mb3">
      <H1>Keyboard shortcuts</H1>

      <H2>
        Formatting <sup>*</sup>
      </H2>
      {renderTwoColumnTable(formattingHintRows, 'w-100 pl3 pb2')}

      <Footnotes className="mt3 mb4 pl3">
        <WithSymbolLeft symbol="*">
          The first leading sentences, `Lede`, of your writing
          and `code block` are the only exceptions where
          no formatting is allowed.
        </WithSymbolLeft>
      </Footnotes>

      <H2>Application</H2>
      {renderTwoColumnTable(applicationHintRows, 'w-100 mb4 pl3')}

    </div>
  </PanelFrame>
);


export default BlogUserGuidePanel;



// WEBPACK FOOTER //
// ./src/components/modules/blog/BlogUserGuidePanel.js